/**
 * SDLC Workspace stage definitions.
 *
 * Each stage corresponds to a tab in the SDLC tool and is associated with
 * a route segment under `/tools/sdlc/<stage.id>`. New stages can be added
 * here and they will automatically appear in the navigation; routing is
 * wired in App.js.
 */

export const SDLC_STAGES = [
  {
    id: 'idea',
    label: 'Idea',
    icon: '💡',
    agent: 'intake',
    artifact: 'Idea brief',
    description: 'Capture the idea and complete the framing questions.'
  },
  {
    id: 'requirements',
    label: 'Requirements',
    icon: '📋',
    agent: 'requirements-agent',
    artifact: 'Functional and non-functional requirements',
    description: 'Generate the requirements baseline that drives the delivery pipeline.'
  },
  {
    id: 'architecture',
    label: 'Design',
    icon: '🏛️',
    agent: 'design-agent',
    artifact: 'High-level and low-level architecture design',
    description: 'Generate architecture, components, data model, and diagram instructions.'
  },
  {
    id: 'docs',
    label: 'Docs',
    icon: '📚',
    agent: 'documentation-agent',
    artifact: 'HLD, LLD, ADRs, runbooks, and README',
    description: 'Create implementation documentation from requirements and design.'
  },
  {
    id: 'code',
    label: 'Code',
    icon: '💻',
    agent: 'code-generation-agents',
    artifact: 'Complete project folder with source files and setup',
    description: 'Generate a structured, working project from the approved design.'
  },
  {
    id: 'tests',
    label: 'Tests',
    icon: '🧪',
    agent: 'test-agent',
    artifact: 'Unit, integration, and smoke test suites',
    description: 'Generate test coverage for the produced codebase.'
  },
  {
    id: 'cicd',
    label: 'CI/CD',
    icon: '🔁',
    agent: 'devops-agent',
    artifact: 'Pipeline definitions and deployment scripts',
    description: 'Generate build, test, package, and release automation.'
  },
  {
    id: 'deployment',
    label: 'Deploy',
    icon: '🚀',
    agent: 'deployment-agent',
    artifact: 'AWS deployment execution plan',
    description: 'Prepare the final AWS deployment action after CI/CD approval.'
  }
];

export const SDLC_DEFAULT_STAGE = SDLC_STAGES[0].id;

export const SDLC_AGENT_FLOW = SDLC_STAGES.filter((stage) => stage.id !== 'idea').map((stage, index) => ({
  ...stage,
  sequence: index + 1,
  requiresHumanApproval: true,
}));
